<header class="nrc-header">
  <div class="nrc-header__centered">
    <div class="nrc-header__logo">
      <img src="assets/images/logo.svg" alt="Nest Builder" />
    </div>
  </div>
</header>
